import { UserFacingErrorCode } from "generated/apollo";

export interface GQLContextErrorSkipCodes {
  errorLinkSkipCodes: UserFacingErrorCode[];
}

export function getErrorLinkSkipCodes(
  context: Partial<GQLContextErrorSkipCodes>,
) {
  return context.errorLinkSkipCodes;
}

export function createErrorLinkSkipCodesContext(
  errorLinkSkipCodes: UserFacingErrorCode[],
): GQLContextErrorSkipCodes {
  return {
    errorLinkSkipCodes,
  };
}
